import React, { FunctionComponent } from 'react';
import { LazyImage } from 'react-lazy-images';
import Companies from '@clearkit/icons/glyphs/Companies';

const ENDPOINT = 'https://logo.clearbit.com';

export interface CKCompanyLogoProps {
  size?: number;
  cornerRadius?: number;
  src?: string;
  className?: string;
  domain?: string;
  alt?: string;
}

const Placeholder = () => {
  return <Companies />;
};

interface CompanyLogoWrapProps
  extends Pick<CKCompanyLogoProps, 'className' | 'size' | 'cornerRadius'> {}

const CompanyLogoWrap: React.FC<CompanyLogoWrapProps> = ({
  children,
  size,
  className,
  cornerRadius,
}) => (
  <div
    className={className}
    style={{
      width: `${size}px`,
      height: `${size}px`,
      borderRadius: `${cornerRadius}px`,
    }}
  >
    <div
      className="ck-avatar ck-avatar--company"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: `${cornerRadius}px`,
      }}
    >
      {children}
    </div>
  </div>
);

export const CKCompanyLogo: FunctionComponent<CKCompanyLogoProps> = ({
  src,
  domain,
  size = 32,
  cornerRadius = 4,
  alt,
  className,
}) => {
  if (!src && !domain) {
    return (
      <CompanyLogoWrap
        className={className}
        size={size}
        cornerRadius={cornerRadius}
      >
        <Placeholder />
      </CompanyLogoWrap>
    );
  }

  const computedSrc = src ? src : `${ENDPOINT}/${domain}`;

  return (
    <CompanyLogoWrap
      className={className}
      size={size}
      cornerRadius={cornerRadius}
    >
      <LazyImage
        src={computedSrc}
        alt={alt}
        placeholder={({ ref }) => <div ref={ref}></div>}
        error={() => <Placeholder />}
        actual={({ imageProps }) => (
          <React.Fragment>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'white',
                width: `${size}px`,
                height: `${size}px`,
                borderRadius: `${cornerRadius}px`,
              }}
            >
              <img
                alt={alt}
                style={{
                  width: 'auto',
                  height: 'auto',
                  maxWidth: `${size}px`,
                  maxHeight: `${size}px`,
                }}
                {...imageProps}
              />
            </div>
          </React.Fragment>
        )}
      />
    </CompanyLogoWrap>
  );
};
